import { useEffect, useState } from "react"
import { Boton, Input, Spinner } from "asocomponents"
import ModalJuicios from "./ModalJuicios";
import JuicioServices from "../../../../../modules/Juicio/application/JuicioServices";

function BuscadorJuicios({ onChange, valorClear, cuitLetrado, valor, width, referente }) {

  const [isUserMedico, setIsUserMedico] = useState()
  const [isUserTecnico, setIsUserTecnico] = useState()
  const [isModalOpen, setIsModalOpen] = useState(false)
  const [selectedItemId, setSelectedItemId] = useState(valor)
  const [isLoading, setIsLoading] = useState(false);

  const abrirModal = () => {
    setIsModalOpen(true)
  }

  const cerrarModal = () => {
    setIsModalOpen(false)
  }

  const blurJuicio = async (e) => {
    if (e.target.value !== undefined && e.target.value !== "") {
      setIsLoading(true)

      const cuit = (isUserMedico === true || isUserTecnico === true) ? undefined : cuitLetrado;
      const juicioService = new JuicioServices(cuit, undefined, undefined, e.target.value);
      const juicios = await juicioService.getJuicios()
      setIsLoading(false)
      if (juicios)
        onChange(juicios[0])
      else
        abrirModal()
    }
  }

  const handleBuscarJuicio = (juicio) => {
    setSelectedItemId(juicio.idJuicio)
    onChange(juicio)
  }

  const handleClearJuicio = () => {
    setSelectedItemId('')
    onChange(undefined)
  }

  const handleJuicio = (valor) => {
    setSelectedItemId(valor)
  }

  useEffect(() => {
    setSelectedItemId('')
    valorClear && onChange(undefined)
  }, [valorClear])

  useEffect(() => {
    setSelectedItemId(valor)
    setIsUserMedico(sessionStorage.getItem('usuario') && JSON.parse(sessionStorage.getItem('usuario')).isUserMedico)
    setIsUserTecnico(sessionStorage.getItem('usuario') && JSON.parse(sessionStorage.getItem('usuario')).isUserTecnico)
  }, [valor])

  return (
    <div className="flex flex-wrap justify-start max-w-screen-xl items-center mr-3">
      {isLoading ?
        <Spinner color="red" size="20" /> :
        <Input type="number" onChange={handleJuicio} valor={selectedItemId} onClear={handleClearJuicio} onBlur={blurJuicio} width={width} />
      }
      <Boton onClick={abrirModal} texto="..." fondo="rojo" height="h-8" width="w-4" alt="Buscador de Juicios" />
      {isModalOpen && <ModalJuicios onClose={cerrarModal} onSearchResult={handleBuscarJuicio} cuitLetrado={cuitLetrado} referente={referente} />}
    </div>
  )
}

export default BuscadorJuicios
